import { map, startCase } from 'lodash';
import campaignPurposesCRUDActions from '../actions/CampaignPurposesCRUDActions';
import Actions from '../actions/actions';
import { promotionalUpdateName } from '../selectors/campaignPurposeSelectors';
import { setBusy, setUnBusy } from './common/commonReducers';

const initialState = {
  busy: false,
  purposes: [],
};

// Sometimes the names returned are not what we want to display to the user
export function formatDisplayName(purposeName) {
  if (!purposeName) {
    return 'None';
  }

  let name = startCase(purposeName).replace('Non ', 'Non-');

  if (name === 'Update') {
    name = promotionalUpdateName;
  } else if (name === 'Confirmed Event Reminder') {
    name = 'Event Attendee Reminder';
  }

  return name;
}

function getPurposesArray(purposes) {
  return map(purposes, (id, purposeName) => {
    const name = formatDisplayName(purposeName);

    return { name, id };
  });
}

const retrievedAllAction = (state, action) => {
  let { purposes } = action.entities;
  purposes = getPurposesArray(purposes);

  return {
    ...state,
    busy: false,
    purposes,
  };
};

export default function campaignPurposes(state = initialState, action) {
  switch (action.type) {
    case campaignPurposesCRUDActions.busyAction:
      return setBusy(state);
    case campaignPurposesCRUDActions.retrievedAllAction:
      return retrievedAllAction(state, action);
    case Actions.UNBUSY:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
